/**
 * Returns true if the provided date string has dd/MM/yyyy format.
 */
export default function isSimpleDate(dateString: string): boolean {
  return /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(
    dateString,
  );
}
